import React, { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import BaseAPI from '../../api/apiurl';

const ApexPCustomer = () => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');
    const fetchData = async () => {
      try {
        const response = await fetch(`${BaseAPI}taskprojectchart?company_id=${company_id}&customer_id=${customer_id}`);
        const data = await response.json();

        if (data.status === 200) {
          setChartData(data.data);
        } else {
          console.error("Error fetching data:", data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (chartData && chartRef.current) {
      const roundedData = chartData.map(item => Math.round(item.count));

      const options = {
        series: [{
          data: roundedData,
        }],
        chart: {
          type: 'bar',
          height: 380
        },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        colors: ['#1760ff'],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter: function (val, opt) {
            return chartData[opt.dataPointIndex].entityname + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: chartData.map(item => item.entityname),
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function () {
                return '';
              }
            },
            formatter: function (val) {
              return parseInt(val).toString();
            }
          }
        },
        legend: {
          show: false,
        },
      };

      const chart = new window.ApexCharts(chartRef.current, options);
      chart.render();
    }
  }, [chartData]);

  return (
    <div id="chart" ref={chartRef} />
  );
};

export default ApexPCustomer;
